<template>
  <b-row
    v-if="tipoProposta === 'semchecklist'"
    align-v="baseline"
  >
    <b-col :cols="mostrar && !proposta.semContratante ? '10' : '12'">
      <empresa-cnpj-select
        v-if="!proposta.semContratante"
        ref="empresaCnpjSelect"
        v-model="value_"
        :label="'Informe o contratante responsável para o financeiro.'"
        :pessoa="pessoaSelecionada"
        :disabled="proposta.semContratante || (propostaId > 0 && !mostrar && statusProposta !== 'naoaprovada' && statusProposta !== 'pendenteenvio') || (getCheckOsConstituicao && getStatusProposta !== 8)"
        :require="!(mostrar || proposta.semContratante || getCheckOsConstituicao)"
        :exibir-botao-criar-pessoa="false"
        :filtros="filtrosEmpresa"
        @input="onEmpresaSelecionada"
        @empresa-criada="onEmpresaSelecionada"
        @pessoa-criada="handlePessoaCriada"
      />

      <b-row>
        <b-col cols="4">
          <b-form-checkbox
            v-model="proposta.semContratante"
            size="sm"
            class="detail-check-contrantante-sm"
            style="margin-top: -0.8rem;"
            :disabled="disableEmpresaESemContrantante || disabledEmpresaSemContrantante"
            @change="selecaoSemContratante"
          >
            Sem Empresa Cadastrada no Honorarium
          </b-form-checkbox>
        </b-col>
        <b-col v-if="proposta.tipoProposta === 'semchecklist'">
          <b-form-checkbox
            v-model="proposta.contratantePessoaFisica"
            size="sm"
            class="detail-check-contrantante-sm"
            style="margin-top: -0.8rem;"
            :disabled="disableEmpresaESemContrantante || disabledEmpresaSemContrantante"
            @change="contratantePessoaFisica"
          >
            Selecionar empresa não vinculada ao contato
          </b-form-checkbox>
        </b-col>
        <b-col v-if="proposta.tipoProposta === 'semchecklist'">
          <b-form-checkbox
            v-model="osConstituicao"
            size="sm"
            class="detail-check-contrantante-sm"
            style="margin-top: -0.8rem;"
            :disabled="true"
          >
            Ordem de Serviço de Constituição
          </b-form-checkbox>
        </b-col>
      </b-row>

    </b-col>
    <b-col
      v-if="mostrar && !proposta.semContratante"
      cols="auto"
    >
      <b-btn
        size="sm"
        variant="primary"
        @click="salvarEmpresas"
      >
        Salvar contratante(s)
      </b-btn>
    </b-col>

    <dados-contratante
      ref="dadosContrante"
      :value="proposta.propostaContratanteDetails"
      :proposta-id="proposta.id"
      :show-alteracao="proposta.propostaContratanteDetails === undefined ? false : true "
      @aprovar="salvarDadosContatante($event)"
    />
  </b-row>
</template>

<style lang="scss">
.detail-check-contrantante-sm.custom-checkbox.b-custom-control-sm
  .custom-control-label::before,
.detail-check-contrantante-sm.input-group-sm
  .custom-checkbox
  .custom-control-label::before {
  left: 0px !important;
}

.detail-check-contrantante-sm.custom-checkbox.b-custom-control-sm
  .custom-control-label {
  font-size: 1rem !important;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'
import { isAdmin, permitidoAcessarRecurso } from '@/auth/utils'
import { abrirEmNovaGuia } from '@/@core/utils/utils'

export default {
  name: 'EmpresaContratante',
  components: {
    DadosContratante: () => import('../dados-contrantante-interno/DadosContratanteInterno.vue'),
    EmpresaCnpjSelect: () => import('@/shared/components/empresa-cnpj-select/EmpresaCnpjSelect.vue'),
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    tipoProposta: {
      type: String,
      default: '',
    },
    pessoa: {
      type: Object,
      default: null,
    },
    mostrarBotao: {
      type: Boolean,
      default: false,
    },
    statusProposta: {
      type: String,
      default: '',
    },
    propostaId: {
      type: Number,
      default: 0,
    },
    proposta: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      valueAttr: null,
      pessoaSelecionada: null,
      mostrar: false,
      obrigatorio: false,
      propostaAtual: {},
      disabledByOsConstituicao: true,
      semContratanteCiente: false,
      disabledEmpresaSemContrantante: false,
    }
  },
  computed: {
    ...mapGetters('proposta', ['getCheckOsConstituicao', 'getStatusProposta']),
    osConstituicao: {
      get() {
        return this.getCheckOsConstituicao
      },
      set(newValue) {
        this.setCheckOsConstituicao(newValue)
        return this.getCheckOsConstituicao
      },
    },
    value_: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
    filtrosEmpresa() {
      if (this.proposta.contratantePessoaFisica) {
        return [{
          Colunas: ['TipoInscricao'],
          Valores: [1],
        }]
      }
      return [{
        Colunas: ['Ativo'],
        Valores: [true],
      }]
    },
    disableEmpresaESemContrantante() {
      return (this.getStatusProposta === 8 && this.proposta.semContratante && this.proposta.empresasVinculadas.some(s => s.empresaResumida?.id > 0))
        || (this.getStatusProposta === 8 && this.valueAttr && this.valueAttr.length > 0)
        || (this.getCheckOsConstituicao && this.getStatusProposta !== 8)
        || (!this.getCheckOsConstituicao && (!this.pessoaSelecionada || !this.pessoaSelecionada.id || (this.propostaId > 0 && this.statusProposta !== 'naoaprovada' && this.statusProposta !== 'pendenteenvio')))
    },
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        this.inicializarEmpresa()
      }
    },
    pessoa(val, oldValue) {
      if (val !== oldValue) {
        this.pessoaSelecionada = val
      }
    },
    mostrarBotao(val, oldVal) {
      if (val !== oldVal) {
        this.mostrar = val
      }
    },
    proposta(val, oldVal) {
      if (val !== oldVal) {
        this.propostaAtual = val
      }
    },
  },
  created() {
    this.pessoaSelecionada = this.pessoa
    this.mostrar = this.mostrarBotao
    this.inicializarEmpresa()
  },
  /* eslint no-underscore-dangle: 0 */
  methods: {
    ...mapActions('listas', ['adicionarContratanteCapa']),
    ...mapActions('proposta', ['setCheckOsConstituicao']),

    getEmpresaInicial() {
      if (!this.value || this.value.length === 0) {
        return null
      }
      const raw = this.value[this.value.length - 1]
      if (!raw) {
        return null
      }
      if (typeof raw === 'string') {
        try {
          return JSON.parse(raw)
        } catch (e) {
          return null
        }
      }
      return raw
    },
    inicializarEmpresa() {
      const empresa = this.getEmpresaInicial()
      if (!empresa) {
        return
      }
      this.valueAttr = empresa
    },

    handlePessoaCriada(pessoaData) {
      // Emite evento para o componente pai (DadosEnvio)
      this.$emit('pessoa-criada', pessoaData)
    },
    onEmpresaSelecionada(empresa) {
      this.value_ = empresa
      this.enviarParaPai()
    },
    enviarParaPai() {
      this.obrigatorio = false
      this.$emit('select', !this.value_ ? null : this.value_)
      this.$emit('input', !this.value_ ? null : this.value_)
      if (this.proposta.statusProposta === 'finalizada') {
        this.disabledEmpresaSemContrantante = true
      }
    },
    salvarEmpresas() {
      if (!this.value_ || this.value_.length === 0) {
        this.$erro('Informe os contratante(s)!')
      } else {
        this.$confirmar('Tem certeza que deseja salvar agora?', 'Ao confirmar a ação o sistema irá salvar o contratante e desabilitará o campo para alteração.', 'question', 'danger')
          .then(result => {
            if (result.value) {
              api.adicionarPropostaEmpresas(this.propostaId, this.value_)
                .then(payload => {
                  this.mostrar = false
                  this.obrigatorio = false
                  this.$sucesso('Salvo com sucesso!')
                  this.adicionarContratanteCapa({ propostaId: this.propostaId, contratante: payload.data })
                  this.$emit('salvo-contratante', this.value_)
                  this.$router.go()
                })
                .catch(err => {
                  this.$handleError(err)
                  throw err
                })
            }
          })
      }
    },
    abrirCadastroEmpresa(value) {
      if (isAdmin()) {
        abrirEmNovaGuia('editar-emp', value)
      } else {
        const ability = permitidoAcessarRecurso('empresa')
        if (ability) {
          if (ability.actions.some(som => som === 'update')) {
            abrirEmNovaGuia('editar-emp', value)
          } else {
            abrirEmNovaGuia('empresas')
          }
        } else {
          this.$erro('Você não tem permissão para acessar esse cadastro. Contate o administrador!')
        }
      }
    },
    selecaoSemContratante(value) {
      if (value) {
        this.$atencao('Atenção', 'Esse parâmetro influencia diretamente na integração dos dados do financeiro na Omie! Somente marque-o, nos casos em que a  empresa contratante não esteja cadastrada no Honorarium.', 'Ciente')
          .then(result => {
            if (result.value && this.proposta.tipoProposta === 'semchecklist' && this.proposta.statusProposta === 'finalizada') {
              this.$refs.dadosContrante.show()
            }
          })
        this.value_ = []
        this.$emit('remover-empresa')
      }
    },
    contratantePessoaFisica(value) {
      if (value) {
        if (this.proposta.tipoProposta === 'semchecklist' && this.proposta.statusProposta === 'finalizada') {
          this.$refs.dadosContrante.show()
        }
        this.value_ = []
        this.$emit('remover-empresa')
      }
    },
    salvarDadosContatante(value) {
      api.adicionarPropostaContratante(this.proposta.id, value)
        .then(payload => {
          this.proposta.propostaContratanteDetails = payload.data
          this.$sucesso('Dados do financeiro alterado com sucesso!')
          this.$router.go()
        })
        .catch(err => {
          this.$handleError(err)
          throw err
        })
    },

    validateCnpjField() {
      if (this.$refs.empresaCnpjSelect && this.$refs.empresaCnpjSelect.validateSelecao) {
        return this.$refs.empresaCnpjSelect.validateSelecao()
      }
      return true
    },
  },
}
</script>
